export default __webpack_public_path__ + "static/og-image-e3688e4fac4bb0ead298ec67c8026025.png";